// TODO - Type 'any' needs to be fixed.

export const resetBroadcastMessageStateReducer = (state:any) => {
    state.broadcastMessage.status = "idle";
    state.broadcastMessage.errorMessage = "";
  }